import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import timeclockInstance from '../../config/timeclockInstance';
import axiosInstance from '../../config/axiosInstance'
import moment from 'moment';
import 'moment/min/locales';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import DuplicatePoint from './DuplicatePoint';
import { fetchUser, clockInOut, downloadReceipt, sendEmail, clockInOutNew } from '../../store/actions/clockInOut';
import { setLoading } from '../../store/actions/general';
import Input from '../../components/Input/Input';
import Camera from '../../components/Camera/Camera';
import RunningTime from '../../components/RunningTime/RunningTime';
import { cpfMask } from '../../shared/masks';
import ConfirmDialog from './../../components/ConfirmDialog/ConfirmDialog';
import Logo from '../../assets/images/logo completa.png';
import { Receipt } from '../../components/TimeclockReceipt/TimeclockReceipt';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { event } from 'react-ga';
import WarningGestor from './WarningGestor';
import { usageLog } from '../../store/actions/globalActions';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@mui/material';


const fpPromise = FingerprintJS.load()

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
    padding: theme.spacing(4),
  },
  clockInOut: {
    marginTop: theme.spacing(6),
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
  },
  buttonRegister: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },

  buttonEntry: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },

  buttonDeparture: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },

  buttonClock: {
    color: '#fff',
    width: '150px',
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
  in: {
    backgroundColor: '#61bb47',
    '&:hover': {
      backgroundColor: '#2b8a15',
    },
  },
  out: {
    backgroundColor: '#e03a3d',
    '&:hover': {
      backgroundColor: '#a70016',
    },
  },
  link: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  linkPrimary: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

class ClockInOut extends React.Component {
  state = {
    cpf: this.props.location.state ? this.props.location.state.cpf : '',
    deviceId: '',
    password: '',
    companyId: null,
    lat: null,
    lng: null,
    open: false,
    openDuplicate: false,
    companies: null,
    newData: null,
    newDataChanged: null,
    disableButton: false,
    justification: null,
    blockedDevice: '',
    modal: false,
    companyName: '',
    companyCode: '',
    isLight: false,
    dtRegister: '',
    type: '',
    messageError: '',
    openMessageError: false
  };

  componentDidMount() {
    if (this.state.cpf !== '') {
      this.handleFetchUser(this.state.cpf);
    }
    if (navigator.geolocation) {
      this.geolocation = navigator.geolocation.getCurrentPosition((position) => {
        if (this.willUnmount) return;
        this.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }


  componentWillUnmount() {
    this.willUnmount = true;
  }

  onCloseReceipt = () => {
    this.setState({ open: false, data: [], companyName: '' });
  }

  onSendEmail = () => {
    this.props.sendEmail(this.state.data.id, this.state.data._token);
    this.setState({ open: false, data: [] });
  }

  handleFetchUser = (cpf) => {
    this.props
      .onFetchUser(cpf)
      .then((response) => {
        this.setState({
          company: response.companies.length && response,
          companyId: response.companies.length && response.companies[0].id,
          password: '',
          blockedDevice: response.companies[0].hasBlockedDevice,
          modal: response.companies[0].hasBlockedDevice == 'MOBILE_ONLY' ? true : false
        });
        if (response.companies.length == 1) {
          this.setState({ companyCode: response.companies[0].companyCode })
          this.getDataCompany(response.companies[0].companyCode)
        }
        if (response.companies.length && response.companies[0].id) {
          this.Visitor(response.companies[0].id);
        }
      })
      .catch(error => error);
  };




  Visitor = (companyId) => {
    fpPromise
      .then(fp => fp.get())
      .then(result => {
        // This is the visitor identifier:
        // const visitorId = result.visitorId;
        this.setState({ deviceId: result.visitorId + companyId });
      })
      .catch(error => console.error(error))
  };

  handleCPFChange = async (event) => {
    if (
      event.target.value &&
      event.target.value.split('')[13] !== '\u2000' &&
      event.target.value !== this.state.cpf
    ) {
      this.handleFetchUser(event.target.value.replace(/\D+/g, ''));

    }

    this.handleChange('cpf')(event);
  };

  handleChange = name => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleClose = () => {
    this.setState({ isLight: false });
  };

  getDataCompany = async (companyCode) => {
    try {
      const dt = {
        "searchTerm": companyCode,
        "value": "Código"
      }
      const response = await axiosInstance.post('infoCompany', dt)
      console.log(response)
      this.setState({ isLight: response.data.isLight })
      if (response.data.isLight) {
        usageLog("Funcionario/Inadimplente/Aviso/Visualizou", response.data.id, null)
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleCompanyName = async (name) => {
    const company = this.state.company.companies.find(company => company.socialName == name)
    this.setState({ companyName: name, companyId: company.id, companyCode: company.companyCode });
    const addressLocation = company.address + '-' + company.district + '-' + company.city
    this.setState({ location: addressLocation })
    await this.getDataCompany(company.companyCode)
  }

  openModal = () => {
    if (this.state.blockedDevice == 'MOBILE_ONLY') {
      this.setState({ modal: true })
    }
  };

  registerWebTimeclock = async (data) => {
    try {
      this.props.onSetLoading(true);
      const response = await this.props.onClockInOut(data, localStorage.token)

      if (response.status && response.status == 200) {
        this.setState({
          cpf: '\u2000', password: '', companyId: null, employeeObs: this.state.justification, data: {}, open: true, disableButton: false, dtRegister: new Date()
        });
        this.props.onSetLoading(false);
      } else {
        this.setState({
          messageError: response,
          openMessageError: true
        })
      }
    } catch (error) {
      console.log(error)
      this.setState({ disableButton: false })
    }
  };

  handleClock = async (type) => {
    try {
      this.setState({ disableButton: true });
      if (this.props.user.companies.length == 1) {
        this.setState({ companyName: this.props.user.companies[0].socialName })
        const addressLocation = this.props.user.companies[0].address + '-' + this.props.user.companies[0].district + '-' + this.props.user.companies[0].city
        this.setState({ location: addressLocation })
      }
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 19).replace('T', ' ');
      const data = {
        ...this.state,
        cpf: this.state.cpf.replace(/\D+/g, ''),
        type,
        dtRegister: formattedDate,
        photoBase64: this.camera.takePicture(),
        employeeObs: this.state.justification,
      };
      const change = type === 'I' ? 'I' : 'O';
      this.setState({ type: type })

      this.setState({ newData: { ...data, type: 'I' }, newDataChanged: { ...data, type: 'O' } });
      if (this.state.modal == false) {

        this.registerWebTimeclock(data);
      }
    } catch (error) {
      console.log(error)
    }
  };

  isValid = () => {
    const {
      cpf, companyId, password, lat, lng,
    } = this.state;
    return !(cpf.trim() !== '' && password.trim() !== '' && companyId && lat && lng);
  };

  dd = {
    content: [
      'First paragraph',
      'Another paragraph, this time a little bit longer to make sure, this line will be divided into at least two lines',
    ],
  };



  render() {
    const {
      classes, userLoading, loading, user,
    } = this.props;
    const {
      cpf, companyId, password, lat, lng, justification,
    } = this.state;

    let clockActions = null;
    if (lat && lng) {
      clockActions = (
        <React.Fragment>
          <Button
            disabled={this.isValid() || this.state.disableButton}
            variant="contained"
            onClick={() => this.handleClock('I')}
            className={classNames(classes.button, classes.buttonClock, classes.in)}
          >
            ENTRADA
          </Button>
          <Button
            disabled={this.isValid() || this.state.disableButton}
            variant="contained"
            onClick={() => this.handleClock('O')}
            className={classNames(classes.button, classes.buttonClock, classes.out)}
          >
            SAÍDA
          </Button>
          <Typography style={{
            opacity: 0.4
          }}>
            ID do Aparelho: {this.state.deviceId}
          </Typography>
        </React.Fragment>
      );
    } else {
      clockActions = (
        <React.Fragment>
          <Typography paragraph color="primary">
            Não é possível bater o ponto pois não conseguimos acessar sua localização. Verifique as
            configurações do seu navegador.
          </Typography>
          <Typography variant="caption" color="textSecondary">
            *Versões anteriores a 9 do Internet Explorer ou Opera Mini não são suportadas.
          </Typography>
        </React.Fragment>
      );
    }

    let collapseContent = null;
    if (!user.hasUser) {
      if (user.employeeName) {
        collapseContent = (
          <React.Fragment>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              {user.employeeName}, você ainda não é registrado.
            </Typography>
            <Typography variant="body1">
              <Link
                to="/registrar-empregado"
                className={classes.linkPrimary}
              >
                Clique aqui e registre-se agora!
              </Link>
            </Typography>
          </React.Fragment>
        );
      }
    } else {
      collapseContent = (
        <React.Fragment>
          <Typography variant="body1" color="textSecondary" paragraph>{user.employeeName}</Typography>
          <Camera
            innerRef={(node) => {
              this.camera = node;
            }}
          />
          <RunningTime />

          <Input
            elementType="select"
            name="company"
            label="Empresa"
            margin="normal"
            required
            fullWidth
            // value={companyId || (user.companies.length && user.companies[0].id)}
            value={user.companies.length == 1 ? user.companies[0].socialName : this.state.companyName}
            options={user.companies.map(company => ({
              value: company.socialName,
              displayValue: company.socialName,
            }))}
            onChange={(event) => this.handleCompanyName(event.target.value)}
          />
          <Input
            elementType="justificatory"
            label="Justificativa (Opcional):"
            margin="normal"
            fullWidth
            value={justification}
            onChange={this.handleChange('justification')}
          />
          <Input
            elementType="passwordToggle"
            name="password"
            label="Senha"
            margin="normal"
            required
            fullWidth
            value={password}
            onChange={this.handleChange('password')}
          />
          <Typography paragraph variant="caption" align="right">
            <Link
              to={{ pathname: '/esqueceu-senha', state: { returnLink: '/ponto-web' } }}
              className={classes.link}
            >
              esqueceu sua senha?
            </Link>
          </Typography>

          {loading ? <CircularProgress color="primary" /> : clockActions}
        </React.Fragment>
      );
    }

    return (
      <Grid container justify="center" alignItems="flex-start" className={classes.container}>
        <Grid container justify="flex-end" style={{ marginBottom: '50px' }}>
          <Typography
            align="right"
            color="textSecondary"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img src={Logo} alt="Puntu" style={{ width: '140px', margin: 'auto' }} />
            <div style={{ position: 'absolute', right: '0' }}>
              <span>Ainda não é registrado?</span>
              <Button
                component={Link}
                to="/registrar-empregado"
                color="inherit"
                className={classNames(classes.button, classes.buttonRegister)}
              >
                Registre-se
              </Button>
            </div>
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8} md={6} lg={4} xl={3} container direction="column">
          <Typography variant="h5" color="textSecondary" gutterBottom>
            Bater o Ponto
          </Typography>

          <Typography color="textSecondary" paragraph>
            Selecione a empresa e o tipo do ponto.
          </Typography>
          <Input
            autoComplete="off"
            elementType="maskedInput"
            name="cpf"
            label="CPF"
            margin="normal"
            mask={cpfMask}
            required
            fullWidth
            value={cpf}
            onChange={this.handleCPFChange}
            helperText="Digite seu CPF para buscar suas empresas"
            InputProps={{
              endAdornment: userLoading ? (
                <InputAdornment position="end">
                  <CircularProgress size={30} color="primary" />
                </InputAdornment>
              ) : null,
            }}
          />

          <Collapse
            in={!!(cpf.replace(/\D+/g, '').length === 11 && !userLoading)}
            className={classes.clockInOut}
          >
            {collapseContent}
          </Collapse>
          <DuplicatePoint
            open={this.state.openDialog}
            disabled={this.state.disableButton}
            handleDuplicateIn={() => {
              this.setState({ disableButton: true });
              this.props
                .onClockInOut(this.state.newData, localStorage.token)
                .then((result) => {
                  this.setState({
                    cpf: '\u2000', password: '', companyId: null, justification: this.state.justification, data: result, open: true, openDialog: false, disableButton: false, dtRegister: new Date()
                  });
                })
                .catch(error => this.setState({ openDialog: false, disableButton: false }));
            }}
            companies={this.state.companies}
            dtRegister={this.state.companies && moment(this.state.companies.refDate).locale('pt-br')}
            handleDuplicateOut={() => {
              this.setState({ disableButton: true });
              this.props
                .onClockInOut(this.state.newDataChanged, localStorage.token)
                .then((result) => {
                  this.setState({
                    cpf: '\u2000', password: '', companyId: null, justification: this.state.justification, data: result, open: true, openDialog: false, disableButton: false, dtRegister: new Date()
                  });
                })
                .catch(error => this.setState({ openDialog: false, disableButton: false }));
            }}
          />
          <ConfirmDialog
            // open={this.state.open}
            open={this.state.open}
            title="Ponto registrado com sucesso"
            confirmText="Enviar por email"
            closeText="FECHAR"
            onClose={this.onCloseReceipt}
            onConfirm={this.onSendEmail}
            noPadding
            content={(
              <Receipt
                data={this.state.data}
                user={this.state.company}
                company={this.state.company ? this.state.company.companies : []}
              />
            )}
            data={this.state.data}
            user={this.state.company}
            company={this.state.company ? this.state.company.companies : []}
            companyName={this.state.companyName}
            location={this.state.location}
            dtRegister={this.state.dtRegister}
            type={this.state.type}
          />
        </Grid>
        <Dialog
          open={this.state.modal}
          maxWidth="sm"
          fullWidth={true}
          PaperProps={{
            style: { borderRadius: 20 }
          }}
        >
          <div style={{ overflowX: 'hidden' }}>
            <DialogTitle style={{
              textAlign: 'center',
              width: '100%',
              fontSize: '30px',
              color: 'white',
              backgroundColor: '#3978D3',
              // borderRadius: '4px',
              padding: '10px',
            }}>
              <a style={{ fontSize: 30 }}><b>Poxa vida :( <br /> Registro bloqueado</b></a>
            </DialogTitle>
            <div style={{ position: "relative", marginTop: 0 }}>
              <DialogContentText
                style={{
                  //   position: "absolute",
                  // color: '#3978D3',
                  //   top: '7%',
                  //   left: "35%",
                  transform: "translateX(-2%)",
                  fontSize: "17px"
                }}
              > <br /><br />
                &emsp;&emsp;&emsp;Seu gestor ainda não liberou o registro de ponto neste dispositivo.<br />
                {/* &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Seu gestor ainda não liberou o registro de ponto Web.<br /> */}
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Por favor,fale com ele para solicitar autorização.<br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Vamos torcer para que ele libere logo!
                <br />
                <br />
              </DialogContentText>
              <Button variant='outlined' color="#ffffff"
                onClick={() => {
                  window.location.reload();
                }}
                style={{ transform: "translateX(120%)", boxShadow: '1px 1px 3px #808080', borderRadius: '10px' }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a style={{ color: '#3978D3' }}><strong>SAIR</strong></a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Button>
              <div><br /><br /></div>
            </div>
          </div>
        </Dialog >


        <Snackbar
          open={this.state.openMessageError}
          autoHideDuration={3000}
          onClose={() => this.setState({ openMessageError: false, disableButton: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
        >
          <Alert onClose={() => this.setState({ openMessageError: false, disableButton: false })}
            severity="error"
            sx={{ width: '100%', backgroundColor: 'white', color: 'red' }}
          >
            Senha errada, tente novamente !
          </Alert>
        </Snackbar>

        
        <WarningGestor open={this.state.isLight} handleClose={this.handleClose} state={this.state} />
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  userLoading: state.clockInOut.loading,
  user: state.clockInOut.user,
});

const mapDispatchToProps = dispatch => ({
  onFetchUser: cpf => dispatch(fetchUser(cpf)),
  onClockInOut: (data, token) => dispatch(clockInOutNew(data, token)),
  downloadReceipt: timeclockId => dispatch(downloadReceipt(timeclockId)),
  sendEmail: (timeclockId, token) => dispatch(sendEmail(timeclockId, token)),
  onSetLoading: () => dispatch(setLoading()),
});

ClockInOut.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  userLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onFetchUser: PropTypes.func.isRequired,
  onClockInOut: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ClockInOut));
